import { render, staticRenderFns } from "./IFAbout.vue?vue&type=template&id=1d7ed09c"
import script from "./IFAbout.vue?vue&type=script&lang=js"
export * from "./IFAbout.vue?vue&type=script&lang=js"
import style0 from "./IFAbout.vue?vue&type=style&index=0&id=1d7ed09c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports